import { useQuery } from '@tanstack/react-query';

import {
  apiGetContactPolicies,
  CONTACT_POLICIES_PAGE_SIZE,
} from 'api/acturis/client-center';

import type { ActurisContactPolicy } from 'api/acturis/client-center';

export const CLIENT_CENTER_CUSTOMER_POLICIES_KEY =
  'client-center-customer-policies';

const EMPTY_POLICIES: ActurisContactPolicy[] = [];

export const useClientCenterCustomerPolicies = (
  customerId: string,
  page = 1,
) => {
  const { data, isLoading, error, refetch, isFetching } = useQuery<
    ActurisContactPolicy[]
  >({
    queryKey: [
      CLIENT_CENTER_CUSTOMER_POLICIES_KEY,
      customerId,
      page,
      CONTACT_POLICIES_PAGE_SIZE,
    ],
    queryFn: () => apiGetContactPolicies(customerId, page),
    enabled: Boolean(customerId),
    staleTime: 30 * 1000,
    retry: false,
  });

  return {
    policies: data ?? EMPTY_POLICIES,
    hasNextPage: (data?.length ?? 0) === CONTACT_POLICIES_PAGE_SIZE,
    isLoading,
    error,
    refetch,
    isFetching,
  };
};
